function initCategoriesCarousel(){
	$('.medical-products-carousel').on('init', function(){
		$('.slick-current').addClass('show-info');
	});
	$('.medical-products-carousel').slick({
		infinite: true,
		focusOnSelect: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 500,
		swipeToSlide:true,
		arrows:false,
		cssEase: 'linear',
		draggable: true
	});
	$('.carousel-trigger').on('click', function(e){
        var slideIndex = $(this).data('index');
		$('.carousel-trigger').removeClass('active');
		$(this).addClass('active');
		$('.medical-products-carousel').slick('slickGoTo', slideIndex, false);
		e.preventDefault();
	});
	
	$('.medical-products-carousel').on('beforeChange', function(){
		$('.medical-products-carousel').css({'height':$('.medical-products-carousel').innerHeight()});
	});
	
	
	$('.medical-products-carousel').on('afterChange', function(){
		var slideIndex = $('.medical-products-carousel .slick-current').data('slick-index');
		$('.medical-products .cat-name a.active').removeClass('active');
		$('.medical-products .cat-name a[data-index="'+slideIndex+'"]').addClass('active');
		$('.medical-products-carousel .show-info').removeClass('show-info');		
		$('.medical-products-carousel .slick-current').addClass('show-info');		
		$('.medical-products-carousel').css({'height':'auto'});
	});
}

function initCategoriesPanels(){
	"use strict";
	$('.panel-group.related-products .panel-heading a').click(function(e){
		var parent = $(this).data('parent');
		if($(this).hasClass('active')){
			$('.related-category-row '+parent+' .panel-heading.active').removeClass('active');
			$('.related-category-row '+parent+' .panel-heading a.active').removeClass('active');
		}else{
			$('.related-category-row '+parent+' .panel-heading.active').removeClass('active');
			$('.related-category-row '+parent+' .panel-heading a.active').removeClass('active');
			$(this).addClass('active');		
		}		
		e.preventDefault();
	});		
	$('body').imagesLoaded( {
		// options...
	},
		function() {
			if( $('.related-category-row.anchor').length>0){
				setTimeout(function(){
					$('html, body').stop().animate( {
					   'scrollTop': $('.related-category-row.anchor').offset().top
					}, 500, 'swing', function () {
						if(!$('.related-category-row .panel-heading.anchor a').hasClass('active')){
							$('.related-category-row .panel-heading.anchor').trigger('click');
							$('.related-category-row .panel-heading.anchor a').trigger('click').addClass('active');	
						}						
					});					
				},1000);				
			}	
		}
    );		
}

